import { setSelectedUser, updateCreateNewStaffField } from '../../../features/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFetching, setTypeModal, setTypeOfShowModalType } from '../../../features/modal/modalSlice';
import { StaffData, UserSelected } from '../../../types/user';
import { selectCurrentGuestUsername, selectCurrentUserId, selectCurrentUserRole } from '../../../features/auth/authSlice';
import { showToast } from '../../../toastify/Toast';
import StaffTHead from '../../common/theads/StaffTHead';
import StaffTBody from '../../common/tbody/StaffTBody';
import { useMasterData } from '../../../hooks/api/useMasterData';
import useStaffSocket from '../../../hooks/socket/useStaffSocket';

export default function StaffTable() {

    const { usersData, isErrorUsersData, isLoadingUsersData, errorMessageUserData, roles, status, } = useMasterData();
    const dispatch = useDispatch();
    const isFetching = useSelector(selectIsFetching)
    const userRole = useSelector(selectCurrentUserRole)
    const userId = useSelector(selectCurrentUserId)
    const guestUsername = useSelector(selectCurrentGuestUsername)
    const isCurrentlyLoading = isLoadingUsersData || isFetching 

    useStaffSocket()

    const handleClickedUpdate = (user: StaffData, role: string) => {
        if(!userRole || !user) return
        const selectedRoleId = user.roleId
        const selectedStatusId = user.statusId

        const selectedUser: UserSelected = {
            id: user.staffID,
            name: user.firstName
        }

        if(userRole === 'User') {
            return showToast('You are not allowed to update this user.', 'error')
        }
        if(userId === user.staffID || guestUsername=== user.firstName) {
            return showToast('You are not allowed to update your own profile.', 'error')
        }
        if(userRole === 'Administrator' && role === 'Super Admin') {
            return showToast('You are not allowed to update this user.', 'error')
        }
        if(userRole === 'Cashier' && (role === 'Super Admin' || role === 'Administrator')) {
            return showToast('You are not allowed to update this user.', 'error')
        }

        dispatch(setTypeModal('updateStaff'));
        dispatch(setTypeOfShowModalType('staffModal'));

        // dispatch(setSelectedStaff(selectedUser))

        const matchedRole = roles.find(r => r.roleId === selectedRoleId);
        const matchedStatus = status.find( s => Number(s.statusId) === Number(selectedStatusId));
        
        dispatch(setSelectedUser(user));

        dispatch(updateCreateNewStaffField({ field: "firstName", value: user.firstName }));
        dispatch(updateCreateNewStaffField({ field: "middleInitial", value: user.middleInitial || "" }));
        dispatch(updateCreateNewStaffField({ field: "lastName", value: user.lastName }));
        dispatch(updateCreateNewStaffField({ field: "email", value: user.email }));
        dispatch(updateCreateNewStaffField({ field: "role", value: matchedRole || null }));
        dispatch(updateCreateNewStaffField({ field: "password", value: user.password }));
        dispatch(updateCreateNewStaffField({ field: "status", value: matchedStatus || null }));
    };

    return (
        <div className='flex-1 overflow-hidden bg-white rounded border'>
            <div className='overflow-y-auto h-full'>
                <table className='min-w-max w-full'>
                    <StaffTHead/>
                    <StaffTBody
                        staff={usersData}
                        handleClickedUpdate={handleClickedUpdate}
                        isLoading={isCurrentlyLoading}
                        isError={isErrorUsersData}
                        errorMessage={errorMessageUserData}
                        isEmpty={usersData.length === 0}
                        roles={roles}
                        status={status}
                    />
                </table>
            </div>
        </div>
    )
}
